import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ShareableLinkAnalyticsResponse } from 'models/ShareableLink';
import usePastTime from 'hooks/usePastTime';
import ContentLoader from 'react-content-loader';

import './SecureLinkAnalyticsHeader.styles.scss';

const skeleton = (
  <ContentLoader
    viewBox="0 0 50 18"
    width={50}
    height={18}
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
  >
    <rect x="0" y="0" rx="6" ry="6" width="50" height="18" />
  </ContentLoader>
);

type SecureLinkAnalyticsHeaderProps = {
  className?: string;
  isLoading?: boolean;
} & Partial<ShareableLinkAnalyticsResponse>;

const SecureLinkAnalyticsHeader: React.FC<SecureLinkAnalyticsHeaderProps> = (
  props,
) => {
  const {
    className,
    isLoading,
    totalAccessCount,
    uniqueVisitorsCount,
    lastAccessDate,
  } = props;

  const classes = classNames('secure-link-analytics-header', className);

  const { t } = useTranslation();

  const lastAccess = usePastTime()(lastAccessDate);

  return (
    <div className={classes}>
      <div>
        <p>{t('totalLinkVisits')}</p>
        {isLoading ? skeleton : <p>{totalAccessCount}</p>}
      </div>
      <div>
        <p>{t('uniqueUsers')}</p>
        {isLoading ? skeleton : <p>{uniqueVisitorsCount}</p>}
      </div>
      <div>
        <p>{t('lastAccess')}</p>
        {isLoading ? skeleton : <p>{lastAccess || t('never')}</p>}
      </div>
    </div>
  );
};

export default SecureLinkAnalyticsHeader;
